import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import classnames from "classnames";
import { useGlobal, getGlobal, setGlobal } from "reactn";
import { useToasts } from "react-toast-notifications";
import { connect } from "react-redux";
import store from "../../store/store";
import { remove as removeUser } from "reducers/user/actions";
import { secureStorage, openInNewTab, handleExternalLinks, spayeeJWT, clearAllStoreData } from "services/utility";
import config from "../../pwaConfig.json"
import { clearUiStates } from "reducers/ui-states/actions";
import { setActiveTab } from "../../actions/layout";

//Import Images
import logo from "../../assets/images/logo/logo-Icon-light.svg";
import logodark from "../../assets/images/logo/logo-Icon-dark.svg";
import avatar1 from "../../img/idolImg.png";
import { Fragment } from "react";
// import installImage from "../../img/install-button.png";
import { withTranslation } from "react-i18next";
import Emitter from "services/EventEmitter";
import { isSafari } from "react-device-detect";
/* import avatar1 from "../../assets/images/users/avatar-1.jpg"; */

function LeftSidebarMenu(props) {
  const state = store.getState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpenMobile, setDropdownOpenMobile] = useState(false);
  const [user, setUser] = useState(state.user);
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [channelActive, setChannelActive] = useState(false);
  const [douteActive, setDouteActive] = useState(false);
  const showLiveClasses =
    user?.school?.activatedProducts?.includes("liveclasses");
  const [lng, setlng] = useState("English");
  const setToken = useGlobal("token")[1];
  const { addToast } = useToasts();
  // const history = useHistory();
  const toggle = () => setDropdownOpen(!dropdownOpen);
  const toggle2 = () => setDropdownOpen2(!dropdownOpen2);
  const toggleMobile = () => setDropdownOpenMobile(!dropdownOpenMobile);
  // Install button related flags handled here
  const [isInstalled, isInstalledState] = useState(
    secureStorage.getItem("pwanotinstalled") === "true" ? false : true
  );
  const [isLaunchedInBrowser, isLaunchedInBrowserState] = useState(
    secureStorage.getItem("launchmode") === "browser-tab" ? true : false
  );
  const [isDeferred, isDeferredState] = useState(
    window.deferredPrompt === null ||
      typeof window.deferredPrompt == "undefined"
      ? false
      : true
  );
  const [showLogoutConfirmModal, setShowLogoutConfirmModal] = useState(false);
  // secureStorage.setItem("activeTab", "");
  const toggleIsInstalled = () => isInstalledState(!isInstalled);
  // Install toggle

  const toggleTab = (tab) => {
    props.setActiveTab(tab);
    props.history.push("/" + tab);
  };

  const panacea = () => {
    // let token = secureStorage.getItem("spayeeJWTtoken");
    // console.log("URL",`${config.panaceaUrl}${token}`)
    let token = spayeeJWT(user.username, user.user_email, secureStorage.getItem("password"));
    openInNewTab(`${config.panaceaUrl}${token}`);
  }
  var bc;
  if (!isSafari) {
    bc = new BroadcastChannel("LOGOUT_MESSAGE");
  }

  useEffect(() => {
    // alert(user.user_type);
    if (!isSafari) {
      bc.onmessage = function (ev) {
        // console.log("message onlogout ------------->", ev);
        if (
          ev.target.name == "LOGOUT_MESSAGE" &&
          ev.data == "LOGOUT CALL FROM OTHER TAB" &&
          ev.origin == window.location.origin
        ) {
          onLogoutClick();
        }
      };
    }

    return () => {
      if (!isSafari) {
        bc.close();
      }
    };
  }, []);

  const onLogoutClick = async () => {
    if (!isSafari) {
      bc.postMessage("LOGOUT CALL FROM OTHER TAB");
    }
    const username = user.username;
    const userType = user.user_type;
    console.log("UserType: ", userType);
    await localStorage.removeItem("token");
    await localStorage.removeItem("user");
    await store.dispatch(removeUser());
    await store.dispatch(clearUiStates());
    await secureStorage.removeItem("reduxstate");
    await secureStorage.removeItem("token");
    await localStorage.clear();
    await secureStorage.clear();
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });
    addToast(`User ${username} logged out!`, {
      appearance: "success",
      autoDismiss: true,
    });
    if (
      userType === "student" ||
      userType === "content_approver" ||
      userType === "content_editor"
    ) {
      if (props.history) props.history.push("/login");
      else props.history.push("/login");
    } else if (userType === "teacher") {
      if (props.history) props.history.push("/login");
      else props.history.push("/login");
    } else if (userType === "principal") {
      if (props.history) props.history.push("/login");
      else props.history.push("/login");
    } else if (userType === "superadmin") {
      if (props.history) props.history.push("/login");
      else props.history.push("/login");
    } else {
      if (props.history) props.history.push("/login");
      else props.history.push("/login");
    }
    await setToken(null);
    await setUser({});
    // var { user } = store.getState();

    // secureStorage.removeItem("reduxstate");
    // console.log("logout call -------->", store.getState());
  };

  // here use below snippet for child routes when set acive class
  //   var str = "Hello world, welcome to the universe.";
  // var n = str.startsWith("Hello");
  let tabs = props.location.pathname.split("/");
  let activeTab = "/" + tabs[1];

  useEffect(() => {
    // console.log("route 1-------------->", secureStorage.getItem("activeTab"));
    // const bc = new BroadcastChannel("test_channel");
    if (secureStorage.getItem("activeTab") == "/home" && activeTab == "/room") {
      setChannelActive(true);
    } else {
      setChannelActive(false);
    }
    if (
      secureStorage.getItem("activeTab") == "/doubts" &&
      activeTab == "/room"
    ) {
      setDouteActive(true);
    } else {
      setDouteActive(false);
    }
    if (
      activeTab == "/home" ||
      activeTab == "/doubts" ||
      activeTab == "/class-rooms"
    ) {
      secureStorage.setItem("activeTab", activeTab);
    }
  }, []);
  const getNav = () => {
    if (
      user.user_type === "student" ||
      user.user_type === "content_approver" ||
      user.user_type === "content_editor"
    ) {
      return (
        <React.Fragment>
          {/* <NavItem id="Channels">
            <NavLink
              id="pills-channels-tab"
              className={classnames({ active: activeTab === "/home" || activeTab === "/room" })}
              onClick={() => {
                toggleTab("channel");
              }}
            >
              <i className="icon-channel"></i>
              <span className="nav-Text">Chat</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="Channels" placement="top">
            Chat
          </UncontrolledTooltip> */}

          <NavItem id="concepts">
            <NavLink
              id="pills-user-tab"
              className={classnames({ active: activeTab === "/concepts" })}
              onClick={() => {
                toggleTab("concepts");
              }}
            >
              <i className="icon-learn "></i>
              <span className="nav-Text">Learn</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="concepts" placement="top">
            Learn
          </UncontrolledTooltip>

          <NavItem id="assessment">
            <NavLink
              id="pills-practice-tab"
              className={classnames({ active: activeTab === "/assessment" })}
              onClick={() => {
                toggleTab("assessment");
              }}
            >
              <i className="icon-practice"></i>
              <span className="nav-Text">Practice</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="assessment" placement="top">
            Practice
          </UncontrolledTooltip>
          <NavItem id="panacea" className="d-lg-block">
            <NavLink
              id="Panacea"
              className={classnames({ active: activeTab === "/panacea" })}
              onClick={() => {
                panacea();
              }}
            >
              <i className="icon-reports"></i>
              <span className="nav-Text">Panacea</span>
            </NavLink>
          </NavItem>
          {/* <NavItem id="Channels">
            <NavLink
              id="pills-channels-tab"
              className={classnames({ active: activeTab === "/home" || activeTab === "/room" })}
              onClick={() => {
                toggleTab("home");
              }}
            >
              <i className="icon-channel"></i>
              <span className="nav-Text">Chat</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="Channels" placement="top">
            Chat
          </UncontrolledTooltip> */}
          {/* {showLiveClasses && (<Fragment><NavItem id="student-class-rooms" className="d-none d-lg-block">
            <NavLink
              id="Live classes"
              className={classnames({ active: activeTab === "/live-classes" })}
              onClick={() => {
                toggleTab("live-classes");
              }}
            >
              <i className="icon-live-classes"></i>
              <span className="nav-Text">Live Class</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="student-class-rooms" placement="top">
            Live Class
          </UncontrolledTooltip>
          </Fragment>)
          } */}

          
          {/* <NavItem id="doubts">
            <NavLink
              id="pills-doubt-tab"
              className={classnames({ active: activeTab === "/doubts" })}
              onClick={() => {
                toggleTab("doubts");
              }}
            >
              <i className="icon-ask-doubt"></i>
              <span className="nav-Text">Ask</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="doubts" placement="top">
            Ask Doubts
          </UncontrolledTooltip> */}

          <NavItem id="code" className="d-none d-lg-block">
            <NavLink
              id="pills-bookmarks-tab"
              className={classnames({ active: activeTab === "/code" })}
              onClick={() => {
                toggleTab("code");
              }}
            >
              <i className="icon-code"></i>
              <span className="nav-Text">Code</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="bookmarks"
            className="d-none d-lg-block"
            placement="top"
          >
            Code
          </UncontrolledTooltip>

          <NavItem id="bookmarks" className="d-none d-lg-block">
            <NavLink
              id="pills-bookmarks-tab"
              className={classnames({ active: activeTab === "/bookmarks" })}
              onClick={() => {
                toggleTab("bookmarks");
              }}
            >
              <i className="icon-bookmark-1"></i>
              <span className="nav-Text">Bookmark</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="bookmarks"
            className="d-none d-lg-block"
            placement="top"
          >
            Bookmarks
          </UncontrolledTooltip>
          <NavItem id="leaderboard" className="d-none d-lg-block">
            <NavLink
              id="pills-bookmarks-tab"
              className={classnames({ active: activeTab === "/leaderboard" })}
              onClick={() => {
                toggleTab("leaderboard");
              }}
            >
              <i className="icon-leaderboard"></i>
              <span className="nav-Text">Rank</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="leaderboard"
            className="d-none d-lg-block"
            placement="top"
          >
            Rank
          </UncontrolledTooltip>
          
          <UncontrolledTooltip
            className="d-none d-lg-block"
            target="Panacea"
            placement="top"
          >
            Panacea
          </UncontrolledTooltip>

          {/* <NavItem id="ask-doubts">
            <NavLink
              id="pills-doubt-tab"
              className={classnames({ active: activeTab === "/ask-doubts" })}
              onClick={() => {
                toggleTab("ask-doubts");
              }}
            >
              <i className="icon-ask-doubt"></i>
              <span className="nav-Text">Ask</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="ask-doubts" placement="top">
            Ask Doubts
          </UncontrolledTooltip> */}

          {/* <NavItem id="dashboard" className="d-none d-lg-block">
            <NavLink
              id="pills-bookmarks-tab"
              className={classnames({
                active: activeTab === "/student-dashboard",
              })}
              onClick={() => {
                toggleTab("student-dashboard");
              }}
            >
              <i className="icon-dashboard"></i>
              <span className="nav-Text">Dashboard</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="dashboard"
            className="d-none d-lg-block"
            placement="top"
          >
            Dashboard
          </UncontrolledTooltip> */}

          {/* Superadmin */}
          {user.user_type === "student" && (
            <Fragment>
              <NavItem id="dashboard" className="d-none d-lg-block">
                <NavLink
                  id="dashboard"
                  className={classnames({
                    active:
                      activeTab === "/principal-dashboard" ||
                      activeTab === "/dashboard",
                  })}
                  onClick={() => {
                    toggleTab("dashboard");
                  }}
                >
                  <i className="icon-dashboard"></i>
                  <span className="nav-Text">Dashboard</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip
                className="d-none d-lg-block"
                target="dashboard"
                placement="top"
              >
                Dashboard
              </UncontrolledTooltip>
              {/* <NavItem id="scholarship" className="d-none d-lg-block">
            <NavLink
              id="pills-bookmarks-tab"
              className={classnames({ active: activeTab === '/scholarship' })}
              onClick={() => {
                toggleTab('scholarship')
              }}
            >
              <i className="icon-feed-subject"></i>
              <span className="nav-Text">Scholarship</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="scholarship"
            className="d-none d-lg-block"
            placement="top"
          >
            Scholarship
          </UncontrolledTooltip> */}
            </Fragment>
          )}
        </React.Fragment>
      );
    } else if (
      user.user_type === "teacher" ||
      user.user_type === "principal" ||
      user.user_type === "superadmin"
    ) {
      return (
        <React.Fragment>
          {user.user_type === "teacher" && (
            <Fragment>
              <NavItem id="concepts">
                <NavLink
                  id="pills-user-tab"
                  className={classnames({ active: activeTab === "/concepts" })}
                  onClick={() => {
                    toggleTab("concepts");
                  }}
                >
                  <i className="icon-learn "></i>
                  <span className="nav-Text">Learn</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip target="concepts" placement="top">
                Learn
              </UncontrolledTooltip>
            </Fragment>
          )}

          {/* <NavItem id="channel">
            <NavLink
              id="channel"
              className={classnames({
                active: activeTab === "/home" || channelActive === true,
              })}
              onClick={() => {
                toggleTab("home");
              }}
            >
              <i className="icon-channel"></i>
              <span className="nav-Text">Chat</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="channel" placement="top">
            Chat
          </UncontrolledTooltip> */}
          <NavItem id="create-quiz">
            <NavLink
              id="pills-user-tab"
              className={classnames({ active: activeTab === "/create-quiz" })}
              onClick={() => {
                toggleTab("create-quiz");
              }}
            >
              <i className="icon-assessment"></i>
              <span className="nav-Text">Assessment</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip target="create-quiz" placement="top">
            Assessment
          </UncontrolledTooltip>
          <NavItem id="panacea" className="d-none d-lg-block">
            <NavLink
              id="Panacea"
              className={classnames({ active: activeTab === "/panacea" })}
              onClick={() => {
                panacea();
              }}
            >
              <i className="icon-reports"></i>
              <span className="nav-Text">Panacea</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            className="d-none d-lg-block"
            target="Panacea"
            placement="top"
          >
            Panacea
          </UncontrolledTooltip>
          {/*{user.user_type !== "teacher" && (
            <NavItem id="doubts_t">
              <NavLink
                id="doubts_t"
                className={classnames({
                  active: activeTab === "/doubts" || douteActive === true,
                })}
                onClick={() => {
                  toggleTab("doubts");
                }}
              >
                <i className="icon-doubt"></i>
                <span className="nav-Text">Doubts</span>
              </NavLink>
            </NavItem>
          )} */}

          {/* <UncontrolledTooltip target="doubts_t" placement="top">
            Ask
          </UncontrolledTooltip> */}
          <NavItem id="class-rooms" className="d-none d-lg-block">
            <NavLink
              id="Live classes"
              className={classnames({ active: activeTab === "/class-rooms" })}
              onClick={() => {
                toggleTab("class-rooms");
              }}
            >
              <i className="icon-live-classes"></i>
              <span className="nav-Text">Class Rooms</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            target="class-rooms"
            className="d-none d-lg-block"
            placement="top"
          >
            Class Rooms
          </UncontrolledTooltip>
          <NavItem id="reports" className="d-none d-lg-block">
            <NavLink
              id="Reports"
              className={classnames({ active: activeTab === "/reports" })}
              onClick={() => {
                toggleTab("reports");
              }}
            >
              <i className="icon-reports"></i>
              <span className="nav-Text">Reports</span>
            </NavLink>
          </NavItem>
          {/* {user.user_type === "teacher" && (
            <Fragment>
              <NavItem id="leaderboard">
                <NavLink id="pills-user-tab">
                  <i className="icon-drive"></i>
                  <span className="nav-Text">Drive</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip target="leaderboard" placement="top">
                Drive
              </UncontrolledTooltip>
            </Fragment>
          )} */}
          <UncontrolledTooltip
            className="d-none d-lg-block"
            target="reports"
            placement="top"
          >
            Reports
          </UncontrolledTooltip>
          <NavItem id="calendar" className="d-none d-lg-block">
            <NavLink
              id="Calendar"
              className={classnames({ active: activeTab === "/calendar" })}
              onClick={() => {
                toggleTab("calendar");
              }}
            >
              <i className="icon-calendar"></i>
              <span className="nav-Text">Calendar</span>
            </NavLink>
          </NavItem>
          <UncontrolledTooltip
            className="d-none d-lg-block"
            target="reports"
            placement="top"
          >
            Calendar
          </UncontrolledTooltip>

          {/* Condition for dashboard */}
          {/* Principal */}
          {user.user_type === "principal" && (
            <Fragment>
              <NavItem id="dashboard" className="d-none d-lg-block">
                <NavLink
                  id="dashboard"
                  className={classnames({
                    active:
                      activeTab === "/principal-dashboard" ||
                      activeTab === "/dashboard",
                  })}
                  onClick={() => {
                    toggleTab("dashboard");
                  }}
                >
                  <i className="icon-dashboard"></i>
                  <span className="nav-Text">Dashboard</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip
                className="d-none d-lg-block"
                target="dashboard"
                placement="top"
              >
                Dashboard
              </UncontrolledTooltip>
            </Fragment>
          )}

          {/* Teacher */}
          {user.user_type === "teacher" && (
            <Fragment>
              <NavItem id="dashboard" className="d-none d-lg-block">
                <NavLink
                  id="dashboard"
                  className={classnames({
                    active:
                      activeTab === "/principal-dashboard" ||
                      activeTab === "/dashboard",
                  })}
                  onClick={() => {
                    toggleTab("dashboard");
                  }}
                >
                  <i className="icon-dashboard"></i>
                  <span className="nav-Text">Dashboard</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip
                className="d-none d-lg-block"
                target="dashboard"
                placement="top"
              >
                Dashboard
              </UncontrolledTooltip>
            </Fragment>
          )}

          {/* Superadmin */}
          {user.user_type === "superadmin" && (
            <Fragment>
              <NavItem id="dashboard" className="d-none d-lg-block">
                <NavLink
                  id="dashboard"
                  className={classnames({
                    active:
                      activeTab === "master-dashboard" ||
                      activeTab === "/principal-dashboard" ||
                      activeTab === "/dashboard",
                  })}
                  onClick={() => {
                    let multiArr = localStorage.getItem("multiselectFlagId");
                    if (multiArr === null) {
                      toggleTab("select-school");
                    } else {
                      toggleTab("dashboard");
                    }
                  }}
                >
                  <i className="icon-dashboard"></i>
                  <span className="nav-Text">Dashboard</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip
                className="d-none d-lg-block"
                target="dashboard"
                placement="top"
              >
                Dashboard
              </UncontrolledTooltip>
            </Fragment>
          )}

          {/* { user.user_type === "teacher" ? <>
            <NavItem id="dashboard" className="d-none d-lg-block">

              <NavLink
                id="dashboard"
                className={classnames({ active: activeTab === "principal-dashboard" })}
                onClick={() => {
                  toggleTab("principal-dashboard");
                }}
              >
                <i className="icon-reports"></i>
                <span className="nav-Text">Dashboard</span>
              </NavLink>
            </NavItem>
            <UncontrolledTooltip
              className="d-none d-lg-block"
              target="dashboard"
              placement="top"
            >
              Dashboard
          </UncontrolledTooltip>
          </> :
            <>

              <NavItem id="dashboard" className="d-none d-lg-block">
                <NavLink
                  id="dashboard"
                  className={classnames({ active: activeTab === "master-dashboard" })}
                  onClick={() => {
                    toggleTab("select-school");
                  }}
                >
                  <i className="icon-reports"></i>
                  <span className="nav-Text">Dashboard</span>
                </NavLink>
              </NavItem>
              <UncontrolledTooltip
                className="d-none d-lg-block"
                target="dashboard"
                placement="top"
              >
                Dashboard
         </UncontrolledTooltip>
            </>
          } */}
        </React.Fragment>
      );
    }
  };

  const Picture = () => {
    // src={`${Config.url || ""}/api/images/${user.picture.shieldedID}/256`}
    // if (user) {
    // if (user.picture)
    //   return <img src={user.picture} alt="Picture" className="picture" />;
    // else
    if (user?.first_name) {
      return (
        <div className="btn-group dropup profile-user-dropdown dropdown nav-item nav-circle">
          {user.first_name?.substr(0, 1)}
          {user.last_name?.substr(0, 1)}
        </div>
      );
    } else {
      return <icon class="icon-profile-2"></icon>;
    }

    // }
  };

  const handleClose = () => {
    setShowLogoutConfirmModal(false);
  };

  const handelOpen = () => {
    setShowLogoutConfirmModal(true);
  };

  const changeTheme = (e) => {
    // console.log("change theme ----->", isDarkTheme);
    // if (e.currentTarget.checked) {
    //   secureStorage.setItem("theme", "dark");
    //   Emitter.emit("THEME_NAME", "dark");
    // } else {
    //   secureStorage.setItem("theme", "light");
    //   Emitter.emit("THEME_NAME", "light");
    // }
    if (!isDarkTheme) {
      secureStorage.setItem("theme", "dark");
      Emitter.emit("THEME_NAME", "dark");
    } else {
      secureStorage.setItem("theme", "light");
      Emitter.emit("THEME_NAME", "light");
    }
    setIsDarkTheme(!isDarkTheme);
    // console.log("change theme after----->", isDarkTheme);
  };

  /* changes language according to clicked language menu item */

  return (
    <React.Fragment>
      {/* Please no not change or remove this id 'leftSidebar'  */}
      <div className="side-menu flex-lg-column" id="leftSidebar">
        {" "}
        {/* LOGO */}
        <div className="navbar-brand-box">
          <Link
            to={user.user_type === "student" ? "/concepts" : "/home"}
            className="logo logo-dark"
          >
            {/* <span className="logo-sm">
              <img src={logo} alt="logo" height="40" width="40" />
            </span> */}
          </Link>

          {/* <Link
            to={user.user_type === "student" ? "/concepts" : "/"}
            className="logo logo-light"
          >
            <span className="logo-sm">
              <img src={logodark} alt="logo" height="40" width="40" />
            </span>
          </Link> */}
        </div>
        {/* end navbar-brand-box  */}
        {/* Start side-menu nav */}
        <div className="flex-lg-column my-auto mid-sidenav-content">
          <Nav
            pills
            className="side-menu-nav justify-content-center"
            role="tablist"
          >
            <React.Fragment>
              <NavItem id="logoInMobile">
                <div
                  className="d-block d-lg-none text-center"
                  style={{ paddingTop: "3px" }}
                >
                  <Link
                    to={user.user_type === "student" ? "/concepts" : "/home"}
                    className="logo"
                  >
                    <span className="logo-sm">
                      <img src={logo} alt="logo" height="40" width="40" />
                    </span>
                  </Link>
                </div>
              </NavItem>

              {getNav()}
              {/* rest of the navigation will get through getNav() */}
            </React.Fragment>

            <Dropdown
              nav
              isOpen={dropdownOpenMobile}
              toggle={toggleMobile}
              className="profile-user-dropdown d-inline-block d-lg-none"
            >
              <DropdownToggle nav>
                {/* <img
                  src={logo}
                  alt="chatvia"
                  className="profile-user rounded-circle"
                /> */}
                <Picture />
              </DropdownToggle>
              <DropdownMenu>
                {(user.user_type === "student" ||
                  user.user_type === "content_approver" ||
                  user.user_type === "content_editor") && (
                  <Fragment>
                    <DropdownItem
                      onClick={() => {
                        toggleTab("profile");
                      }}
                    >
                      Profile{" "}
                      <i className="icon-profile-2 float-right text-muted"></i>
                    </DropdownItem>

                    
                    <DropdownItem divider />
                    {/* {showLiveClasses && (<Fragment>
                      <DropdownItem
                      onClick={() => {
                        toggleTab("live-classes");
                      }}
                    >
                      Live Class <i className="icon-live-classes float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider /></Fragment>)} */}
                    <DropdownItem
                      onClick={() => {
                        toggleTab("code");
                      }}
                    >
                      Code <i className="icon-code float-right text-muted"></i>
                    </DropdownItem>
                    
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("bookmarks");
                      }}
                    >
                      Bookmark{" "}
                      <i className="icon-bookmark-1 float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("calendar");
                      }}
                    >
                      Calendar{" "}
                      <i className="icon-calendar float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("leaderboard");
                      }}
                    >
                      Rank{" "}
                      <i className="icon-leaderboard float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    {/* <DropdownItem
                      onClick={() => {
                        toggleTab('scholarship')
                      }}
                    >
                      Scholarship{' '}
              <i className="icon-feed-subject float-right text-muted"></i>

                    </DropdownItem>
                    <DropdownItem divider /> */}
                    <DropdownItem
                      onClick={() => {
                        changeTheme();
                      }}
                    >
                      Theme{" "}
                      <i className="icon-bright float-right text-muted"></i>
                    </DropdownItem> 
                    <DropdownItem divider />
                    {/* <DropdownItem
                      onClick={() => {
                        toggleTab("calendar");
                      }}
                    >
                      Calendar{" "}
                      <i className="icon-reports float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider /> */}
                    
                    {/* {/* <DropdownItem
                      onClick={() => {
                        panacea();
                      }}
                    >
                      Panacea{" "}
                      <i className="icon-leaderboard float-right text-muted"></i>
                    </DropdownItem> */}
                    
                    {(user.user_type === "student" ||
                      user.user_type === "principal") && (
                      <Fragment>
                        {" "}
                        <DropdownItem
                          onClick={() => {
                            toggleTab("dashboard");
                          }}
                        >
                          Dashboard{" "}
                          <i className="icon-dashboard float-right text-muted"></i>
                        </DropdownItem>
                        <DropdownItem divider />
                      </Fragment>
                    )}
                  </Fragment>
                )}

                {(user.user_type === "teacher" ||
                  user.user_type === "principal" ||
                  user.user_type === "superadmin") && (
                  <Fragment>
                    <DropdownItem
                      onClick={() => {
                        toggleTab("class-rooms");
                      }}
                    >
                      Class Room{" "}
                      <i className="icon-live-classes float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("reports");
                      }}
                    >
                      Reports{" "}
                      <i className="icon-reports float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("calendar");
                      }}
                    >
                      Calendar{" "}
                      <i className="icon-calendar float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("dashboard");
                      }}
                    >
                      Dashboard{" "}
                      <i className="icon-dashboard float-right text-muted"></i>
                    </DropdownItem>

                    <DropdownItem divider />
                    <DropdownItem
                      onClick={() => {
                        toggleTab("profile");
                      }}
                    >
                      Profile{" "}
                      <i className="ri-profile-line float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                    {/* <DropdownItem>
                      Drive{" "}
                      <i className="icon-drive float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider /> */}
                  </Fragment>
                )}

                <DropdownItem
                  onClick={() => {
                    handelOpen();
                  }}
                >
                  Log out{" "}
                  <i className="icon-logout-1 float-right text-muted"></i>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </div>
        {/* end side-menu nav */}
        <div className="navbar-profile-box flex-lg-column d-none d-lg-block">
          <Nav className="side-menu-nav justify-content-center">
            {/* {(user.user_type === "student" ||
              user.user_type === "content_approver" ||
              user.user_type === "content_editor") && (
              <Fragment>
                <NavItem id="leaderboard">
                  <NavLink
                    id="pills-user-tab"
                    className={classnames({
                      active: activeTab === "/leaderboard",
                    })}
                    onClick={() => {
                      toggleTab("leaderboard");
                    }}
                  >
                    <i className="icon-leaderboard"></i>
                    <span className="nav-Text">Rank</span>
                  </NavLink>
                </NavItem>
              </Fragment>
            )} */}

            {/* {user.user_type === "teacher" && (
              <Fragment>
                <NavItem id="leaderboard">
                  <NavLink id="pills-user-tab">
                    <i className="icon-drive"></i>
                    <span className="nav-Text">Drive</span>
                  </NavLink>
                </NavItem>
                <UncontrolledTooltip target="leaderboard" placement="top">
                  Drive
                </UncontrolledTooltip>
              </Fragment>
            )} */}

            {/* <NavItem>
              <NavLink id="light-dark">
                <i className="icon-search"></i>
                <span className="nav-Text">Search</span>
              </NavLink>
              <UncontrolledTooltip target="light-dark" placement="top">
                Search
              </UncontrolledTooltip>
            </NavItem> */}

            <Dropdown
              nav
              isOpen={dropdownOpen}
              className="btn-group dropup profile-user-dropdown"
              toggle={toggle}
            >
              <DropdownToggle nav>
                {/* <img
                  src={logo}
                  alt=""
                  className="profile-user rounded-circle"
                /> */}
                <Picture />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    toggleTab("profile");
                  }}
                >
                  Profile{" "}
                  <i className="icon-profile-2 float-right text-muted"></i>
                </DropdownItem>

                <DropdownItem divider />

                {user.user_type === "student" && (
                  <Fragment>
                    <DropdownItem
                      onClick={() => {
                        changeTheme();
                      }}
                      style={{ border: "1px solid transparent" }}
                    >
                      Theme{" "}
                      <i className="icon-bright float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                  </Fragment>
                )}

                {user.user_type === "student" && (
                  <Fragment>
                    <DropdownItem
                      onClick={() => {
                        toggleTab("calendar");
                      }}
                    >
                      Calendar{" "}
                      <i className="icon-calendar float-right text-muted"></i>
                    </DropdownItem>
                    <DropdownItem divider />
                  </Fragment>
                )}

                {/*  <DropdownItem
                  onClick={() => {
                    toggleTab("code");
                  }}
                >
                  Code <i className="icon-code float-right text-muted"></i>
                </DropdownItem> */}
                {/* <DropdownItem divider /> */}

                {/* <DropdownItem
                  onClick={() => {
                    toggleTab("");
                  }}
                >
                  Search <i className="icon-search float-right text-muted"></i>
                </DropdownItem>
                <DropdownItem divider /> */}

                <DropdownItem
                  onClick={() => {
                    handelOpen();
                  }}
                >
                  Log out{" "}
                  <i className="icon-logout-1 float-right text-muted"></i>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </div>
        {/* Side menu user */}
        <Modal
          isOpen={showLogoutConfirmModal}
          hidefunction={() => {
            handleClose();
          }}
        >
          <ModalHeader closeButton>{"STEPApp"}</ModalHeader>
          <ModalBody>{"Do you want to Logout?"}</ModalBody>
          <ModalFooter>
            {/* <button
              variant="outline-secondary"
              onClick={() => {
                handleClose();
              }}
              className="modal-button btn btn-outline"
            >
              {" "}
              {"No"}
            </button> */}
            <button
              variant="primary"
              onClick={() => {
                onLogoutClick();
              }}
              className="btn btn-outline"
            >
              {" "}
              {"Yes"}
            </button>
            <button
              onClick={() => {
                handleClose();
              }}
              className="btn btn-primary"
            >
              {" "}
              {"No"}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default React.memo(
  connect(mapStatetoProps, {
    setActiveTab,
    withTranslation,
  })(LeftSidebarMenu)
);
